import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from '@angular/router';
import { Profil } from '@karl/entities';
import { catchError, EMPTY, firstValueFrom, map } from 'rxjs';
import { RestService } from '../../rest/rest.service';
import { RestUserService } from '../../rest/user.service';
import { RouterService } from '../services/router.service';
import { AuthStore } from '../store/auth/auth.store';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate,
                                            CanActivateChild {

  private routerService = inject(RouterService);
  private authStore = inject(AuthStore);
  private userService = inject(RestUserService)

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.checkIfLoggedIn(route, state);
  }

  async canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.checkIfLoggedIn(childRoute, state);
  }

  private async checkIfLoggedIn(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (this.authStore.getCurrentUser()) {
      if (this.authStore.getCurrentUser().loggedInUser?.profil?.status === Profil.STATUS_ACTIVE) {
        return true;
      } else {
        this.routerService.navigateVerifyUser();
      }
    }
    // Wenn kein User im store liegt -> (neu) lesen probieren und in den store legen
    const loggedIn = await firstValueFrom(this.userService
      .isLoggedIn());
    if (loggedIn) {
      const user = await firstValueFrom(this.userService.setLoggedInUser(true));
      if (user) {
        if (user?.profil?.status === Profil.STATUS_ACTIVE) {
          return true;
        } else {
          this.routerService.navigateVerifyUser();
        }
      }
      return false;
    }
    return false;
  }
}
